import React from 'react';

import autoBind from 'react-autobind';
import { If, Then, Else } from 'react-if'

// import other components within the same project here

import Localization from "composer/Localization.jsx"

import SchoolList from "composer/views/storage/SchoolList.jsx"
import UserList from "composer/views/storage/UserList.jsx"

import {
  Button,
  TextField,
  Grid,
  FormControl,
  Select,
  MenuItem,
  Divider,
  InputAdornment,
  IconButton,
  Icon,
} from '@material-ui/core';

class AdminCreateSchoolForm extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      newSchool: {
        schoolName: "",
        schoolNameEn: "",
        schoolKey: "",
        remark: "",
        locale: 2,
        schoolType: 0,
      },
      userList: [],
      demoLocaleName: "",

      schoolLocale: [],
      schoolType: [],
    };
    autoBind(this);

    // console.log("admin create school constructor");
    this.refreshCreateSchoolTab();
  }

  handleChange = name => event => {
    let school = this.state.newSchool;
    school[name] = event.target.value;
    this.setState({ newSchool: school });
    this.state.newSchool = school;
  }

  refreshCreateSchoolTab(){
    console.log("refreshCreateSchoolTab");

    // get school locale
    this.props.root.refs.API.request("get_school_locale", null, this.getSchoolLocaleOK, this.getSchoolLocaleFailed);

    // get school type
    this.props.root.refs.API.request("get_school_type", null, this.getSchoolTypeOK, this.getSchoolTypeFailed);
  }

  getSchoolLocaleOK(res){
    console.log("getSchoolLocaleOK");
    console.log(res);

    this.setState({
      schoolLocale : res.body['result'],
    });
    this.state.schoolLocale = res.body['result'];
  }

  getSchoolLocaleFailed(res){
    console.log("getSchoolLocaleFailed");
  }

  getSchoolTypeOK(res){
    console.log("get school type ok");
    console.log(res);

    this.setState({
      schoolType : res.body['result'],
    });
    this.state.schoolType = res.body['result'];
  }

  getSchoolTypeFailed(res){
    console.log("getSchoolTypeFailed");
  }

  onSchoolSelected(school) {
    if (school != null) {
      let user = this.state.newUser;
      user['schoolID'] = school.value;
      user['schoolKey'] = school.key;
      user['username'] = "s" + school.value;
      this.setState({
        newUser: user,
      });
      this.state.newUser = user;

      this.props.root.refs.API.request("get_user_data_by_school_id", {school_id: school.value}, this.getUserDataBySchoolIdOK, this.getUserDataBySchoolIdFailed);
    }
  }

  getUserDataBySchoolIdOK(res) {
    let sortedData = res.body['result'].sort(function(a, b) {
      if (a['username'].toLowerCase() < b['username'].toLowerCase()) {
        return -1;
      }
      else if (a['username'].toLowerCase() > b['username'].toLowerCase()) {
        return 1;
      }
      else {
        return (parseInt(a['id']) < parseInt(b['id']) ? -1 : 1);
      }
    });
    this.setState({
      userList: sortedData,
    })
    this.state.userList = sortedData;
  }

  getUserDataBySchoolIdFailed(err) {
    console.log("get user data by school id failed");
  }

  validateInput() {
    let result = true;
    let errorMessage = "";

    if (this.state.newSchool.schoolName.trim() == "" || this.state.newSchool.schoolNameEn.trim() == "") {
      errorMessage = "School name cannot be blank";
      result = false;
    }
    else if (this.state.newSchool.schoolKey.trim() == ""){
      errorMessage = "School key cannot be blank";
      result = false;
    }

    if (errorMessage != "") {
      this.props.root.addNotification(errorMessage);
    }

    return result;
  }

  createSchoolClicked() {
    if (this.validateInput()) {
      console.log("school info validation passed");
      let requestObj = {};
      requestObj['name'] = this.state.newSchool.schoolName.trim();
      requestObj['name_eng'] = this.state.newSchool.schoolNameEn.trim();
      requestObj['key'] = this.state.newSchool.schoolKey.trim();
      requestObj['locale'] = this.state.schoolLocale[this.state.newSchool.locale].locale;
      requestObj['school_type'] = this.state.newSchool.schoolType;

      if(this.state.schoolNameText != ""){
        requestObj['remark'] = this.state.newSchool.remark.trim();
      }

      console.log(requestObj);

      // comment out for debug first
      this.props.root.refs.API.request("create_school", requestObj, this.createSchoolOK, this.createSchoolFailed);
      
    }else{
      console.log("school info validation failed");
    }
    console.log("createSchoolClicked");
  }

  createSchoolOK(res){
    console.log("createSchoolOK");
    console.log(res);

    // although createSchoolOK is called
    // school creation might be rejected
    // 1. empty school name
    // 2. duplicated school key

    let newSchoolID = res.body['result'];
    if(newSchoolID > 0){
      // create school success
      this.props.root.addNotification("New School Created");
    }else{
      // create school failed, school name empty / school key is used
      this.props.root.addNotification("Create School Failed, school name is empty / school key is used");
    }
  }

  createSchoolFailed(res){
    console.log("createSchoolFailed");
    console.log(res);
  }

  render() {
    return (
      <div>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} sm={2}>
            School Name
          </Grid>
          <Grid item xs={12} sm={10}>
            <TextField
              value={this.state.newSchool.schoolName}
              onChange={this.handleChange('schoolName')}
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            School Name (EN)
          </Grid>
          <Grid item xs={12} sm={10}>
            <TextField
              value={this.state.newSchool.schoolNameEn}
              onChange={this.handleChange('schoolNameEn')}
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            School Key
          </Grid>
          <Grid item xs={12} sm={10}>
            <TextField
              value={this.state.newSchool.schoolKey}
              onChange={this.handleChange('schoolKey')}
              helperText="Should be unique"
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            Remark
          </Grid>
          <Grid item xs={12} sm={10}>
            <TextField
              value={this.state.newSchool.remark}
              onChange={this.handleChange('remark')}
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            Locale
          </Grid>
          <Grid item xs={12} sm={10}>
            <FormControl>
              <Select
                value={this.state.newSchool.locale}
                onChange={this.handleChange('locale')}
              >
                {
                  this.state.schoolLocale.map((row, i) => (
                    <MenuItem value={i}>{row['locale']}</MenuItem>
                  ))
                }
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={2}>
            School Type
          </Grid>
          <Grid item xs={12} sm={10}>
            <FormControl>
              <Select
                value={this.state.newSchool.schoolType}
                onChange={this.handleChange('schoolType')}
              >
                {
                  this.state.schoolType.map((row, i) => (
                    <MenuItem value={i}>{row['name']}</MenuItem>
                  ))
                }
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={2}>
          </Grid>
          <Grid item xs={12} sm={10}>
            <Button
              color="primary"
              variant="contained"
              onClick={this.createSchoolClicked}
            >
              {Localization.strings.CREATE}
            </Button>
          </Grid>
        </Grid>
      </div>
    )
  }
}

export default AdminCreateSchoolForm;
